export const prefixClasses = (prefix='formula') => ({
  formula:  prefix,
  bare:     `${prefix}--bare`,
  checkbox: `${prefix}--checkbox`,
  checked:  `${prefix}--checked`,
  controls: `${prefix}--controls`,
  debug:    `${prefix}--debug`,
  disabled: `${prefix}--disabled`,
  errors:   `${prefix}--errors`,
  field:    `${prefix}--field`,
  fluid:    `${prefix}--fluid`,
  focus:    `${prefix}--focus`,
  help:     `${prefix}--help`,
  inline:   `${prefix}--inline`,
  input:    `${prefix}--input`,
  invalid:  `${prefix}--invalid`,
  option:   `${prefix}--option`,
  optional: `${prefix}--optional`,
  panel:    `${prefix}--panel`,
  prefix:   `${prefix}--prefix`,
  prefixed: `${prefix}--prefixed`,
  radio:    `${prefix}--radio`,
  required: `${prefix}--required`,
  suffix:   `${prefix}--suffix`,
  suffixed: `${prefix}--suffixed`,
  valid:    `${prefix}--valid`,
  wide:     `${prefix}--wide`
})
export const BEMClasses = prefixClasses()